<template>
    <img v-if="imageUrl" class="aurora-icon aurora-illustration" :src="imageUrl" :data-icon="name"
        :data-illustration="name" width="24" height="24" alt="" aria-hidden="true" :draggable="false"
        decoding="async">
    <AuroraIcon v-else :name="name" />
</template>

<script>
import AuroraIcon from './index.vue'
import { illustrations } from './illustrations'

export default {
    name: 'AuroraArtIcon',
    components: { AuroraIcon },
    props: {
        name: { type: String, required: true }
    },
    computed: {
        imageUrl() {
            return illustrations[this.name] || ''
        }
    }
}
</script>

<style scoped>
.aurora-illustration {
    display: inline-block;
    flex-shrink: 0;
    vertical-align: middle;
    object-fit: contain;
    pointer-events: none;
    user-select: none;
}
</style>
